// extracted by mini-css-extract-plugin
module.exports = {"authorImage":"AuthorPage_authorImage__AwVTA","description":"AuthorPage_description__INjoJ"};